










import {$} from 'simpli-web-sdk'
import {Component, Prop, Vue, Model, Emit} from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class ItDateInput extends Vue {
  @Prop({type: String}) value!: string | null
  @Prop({type: String}) label!: string | null
  @Prop({type: Boolean}) disabled?: boolean

  inputFromDt(dt: string | null) {
    return dt ? moment(dt).format($.t('dateFormat.inputdate')) : null
  }

  dtFromInput(dt: string | null) {
    if (!dt) {
      return null
    }

    const dtMoment = moment(dt)

    if (dtMoment.year() < 1000 || dtMoment.year() > 9999) {
      return null
    }

    return dtMoment.format()
  }

  get valueAsInput() {
    return this.value ? this.inputFromDt(this.value) : null
  }

  set valueAsInput(val) {
    if (!val) {
      return
    }

    const dt = this.dtFromInput(val)

    if (dt) {
      this.$emit('input', dt)
    }
  }

  emitEmpty() {
    this.$emit('input', null)
  }
}
